import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowBackIcon } from "../../../util/Icons";
import SubMenuWrapper, { SubMenuItem } from "../../../util/SubMenu";

export default function TenKPlan() {
    useEffect(() => {
        document.title = "10K Training Plan - MCC";
    }, []);

    return (
        <div className="min-h-screen py-8 px-2 md:px-4" style={{ background: '#ffffff' }}>
            <div className="max-w-4xl mx-auto">
                {/* SubMenu */}
                <SubMenuWrapper>
                    <SubMenuItem icon={<ArrowBackIcon size={24} color="#6b7280" />} label={"Training Plans"} to={"/training-plans"} />
                </SubMenuWrapper>

                {/* Hero Section */}
                <div className="text-center mb-6 mt-4">
                    <span className="inline-block px-4 py-1 rounded-full text-sm font-medium mb-3" style={{
                        background: 'linear-gradient(90deg, #f97316 0%, #ea580c 100%)',
                        color: 'white'
                    }}>
                        🏃‍♀️ 10K Plan
                    </span>
                    <h1 className="text-3xl md:text-4xl font-extrabold mb-3" style={{
                        background: 'linear-gradient(90deg, #1e293b 0%, #334155 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                    }}>
                        10K Training Plan
                    </h1>
                    <p className="text-base md:text-lg" style={{ color: '#64748b' }}>
                        Take your running to the next level with structured 10K training.
                    </p>
                </div>

                {/* Placeholder Content */}
                <div className="rounded-2xl p-8 text-center" style={{
                    background: 'linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%)',
                    border: '1px solid rgba(249, 115, 22, 0.15)'
                }}>
                    <span className="text-6xl mb-4 block">🚧</span>
                    <h2 className="text-xl font-bold mb-2" style={{ color: '#1e293b' }}>
                        Content Coming Soon
                    </h2>
                    <p className="text-base" style={{ color: '#64748b' }}>
                        The 10K training plan content is being developed. Check back soon!
                    </p>
                </div>
            </div>
        </div>
    );
}
